import { config } from '@/config'
import EXIF from 'exif-js'
import MegaPixImage from '@koba04/ios-imagefile-megapixel'

let util = {

  // 设置网站标题
  title: title => {
    title = title || config.title
    window.document.title = title
  },

  // 如果是省级返回两位数, 市级返回4位数
  dist6Trim(dist6) {
    if (!dist6)
      return null

    if (dist6.substr(2, 4) === '0000')
      return dist6.substr(0, 2)

    if (dist6.substr(4, 2) === '00')
      return dist6.substr(0, 4)

    return dist6
  },

  // 生成随机uuid
  uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0,
        v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },

  //遍历树形结构，并且执行传入方法
  tree: {
    filter(tree, fun) {
      tree.map(item => {
        fun(item)
        if (item.children && item.children.length) {
          util.tree.filter(item.children, fun)
        }
      })
    }
  },
  //dataUrl转blob
  urlToBlob(url) {
    var arr = url.split(','),
      mime = arr[0].match(/:(.*?);/)[1]
    var bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);

    }
    return new Blob([u8arr], { type: mime });
  },
  tableData(arr, { payload, id, key }) {
    key = key || 'id'
    if (id || id === 0) {
      arr.splice(arr.indexOf(arr.find(item => item[key] == id)), 1)
    } else {
      const node = arr.find(item => item[key] == payload[key])
      if (node) {
        Object.assign(node, payload)
      } else {
        arr.unshift(payload)
      }
    }
    return arr
  },
  setPhotoUpload(form, obj) {
    return Object.keys(form).map(item => {
      if (form[item].single === undefined || form[item].single === true) {
        Object.assign(form[item], { list: obj[item] ? [{ url: obj[item], name: obj[item] }] : [], uploadFiles: [] })
      } else {
        Object.assign(form[item], { list: obj[item] ? obj[item].map(ossPath => { return { url: ossPath, name: ossPath } }) : [], uploadFiles: [] })
      }
    })
  },
  getPhotoUploadOss(form, obj) {
    Object.keys(form).map(item => obj[item] = form[item].getOss ? form[item].getOss() : null)
  },
  toJson(info) {
    let json = info.replace(/\n/g, "--n--").replace(/\r/g, "--r--")
    json = JSON.parse(json)
    Object.keys(json).map(item => {
      if (json[item] && typeof json[item] == 'string' && json[item].indexOf('--n--') > -1) {
        json[item] = json[item].replace(/--n--/g, '\n').replace(/--r--/g, '\r')
        json[item + 'Url'] = 'data:image/jpeg;base64,' + json[item]
      }
    })
    return json
  },
  promise(vm, fun) {
    return new Promise((resolve, reject) => {
      vm.$Spin.show({
        render: h => {
          return h("div", [h("Icon", { class: "demo-spin-icon-load", props: { type: "load-a", size: 34 } }), h("div", { class: "f-14 m-t-20" }, "证件读取中...")]);
        }
      })
      let res
      try {
        res = fun()
      } catch (e) {
        vm.$Notice.warning({ title: '读取失败' })
        reject(e)
      }
      if (res.success) {
        resolve(res).call(vm)
      } else {
        reject(res)
      }
    }).finally(() => {
      vm.$Spin.hide();
    })
  },
  ctlActivelSealSupoot(Test, vm) {
    let err = true
    try {
      Test.CopyRights()
    } catch (e) {
      vm.$Modal.confirm({
        title: '使用本功能需要正确安装启用控件！',
        content: '检测到您的电脑未正确安装启用控件，请前往控件安装页面下载安装后才能使用本功能。',
        okText: '前往安装',
        cancelText: '以后再装',
        onOk() {
          vm.$router.push({ path: '/system/help/controlProblem' })
        }
      })
      err = false
    }
    return err
  },
  // 返回一个字符串str, 第n次出现字符cha的位置
  findStrByCha(str, n, cha) {
    let num = 0,
      atIndex
    for (let index = 0; index < str.length; index++) {
      if (str[index] == cha) {
        num++
        if (num == n) {
          atIndex = index
          break
        }
      }
    }
    return atIndex || -1
  },
  formatDate(date, fmt) {
    date = Date.new(date)
    fmt = fmt || 'yyyy-MM-dd HH:mm:ss'
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
      }
    }
    return fmt;
  },
  // 参数分别为日期对象，增加的类型，增加的数量
  dateAdd(date, key, Number) {
    switch (key) {
    case 's':
      return new Date(Date.parse(date) + (1000 * Number));
    case 'n':
      return new Date(Date.parse(date) + (60000 * Number));
    case 'h':
      return new Date(Date.parse(date) + (3600000 * Number));
    case 'd':
      return new Date(Date.parse(date) + (86400000 * Number));
    case 'w':
      return new Date(Date.parse(date) + ((86400000 * 7) * Number));
    case 'M':
      return new Date(date.getFullYear(), date.getMonth() + Number, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    case 'y':
      return new Date(date.getFullYear() + Number, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    }
  }
}

Date.new = (val) => {
  if (val) {
    if (typeof val === 'object') {
      return val
    } else if (typeof val === 'string') {
      return new Date(val.replace(/-/g, '/'))
    } else {
      return new Date(val)
    }
  } else return new Date()
}
export default util
